import sanityClient from "@sanity/client"

export const buildSanityClient = () =>
  sanityClient({
    projectId: process.env.SANITY_PROJECT_ID ?? "",
    dataset: process.env.SANITY_DATASET ?? "",
    useCdn: true,
  })
